import { APP_INITIALIZER, EnvironmentProviders, ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { ComponentsModule } from '../components/component.module';
import { UtilityModule, OnlineService } from '@nts/std/utility';
import { AuthService } from '../auth/auth.service';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthHttpInterceptor } from '../auth/auth-http-interceptor.service';
import { CurrentSessionService } from '../auth/current-session.service';
import { WebApiServiceAgent } from '../api-clients/web-api-service-agent';
import { EndPointResolver } from '../api-clients/end-point-resolver';
import { ResponseCacheService } from '../responses/response-cache.service';
import { FrameworkServiceApiClient } from '../api-clients/framework-service-api-client';
import { TokenService } from '../auth/token.service';
import { LOG_DECYCLE_LIB, LOG_LEVEL } from '@nts/std/utility';
import { JsonNetDecycle } from '@nts/std/serialization';
import { EnvironmentConfiguration } from '@nts/std/environments';
// import { RESPONSE_CACHE_WEBWORKER_FACTORY } from '@nts/std/token';
import { ErrorNotificationService } from '@nts/std/utility';
import { provideSvgIconsConfig } from '@ngneat/svg-icon';
import { coreIcons } from '../icons/core';
import { stdUnknownIcon } from '../icons/core/unknown';
import { CurrentRouteService } from '../routing/current-route.service';
import { ToastMessageService } from '../components';
import { StdInitService } from './std-init.service';
import { AuthRequestService } from '../auth';

export function initializerFactoryFunction(
    stdInitService: StdInitService,
) {
    // Do initing of services that is required before app loads
    // NOTE: this factory needs to return a function (that then returns a promise)
    return async () => {
        await stdInitService.init();
    };
}
@NgModule({
    declarations: [
    ],
    providers: [
    ],
    imports: [
        ComponentsModule,
    ],
    exports: [
        ComponentsModule,
    ]
})
export class StdModule {
    static forRoot(): ModuleWithProviders<StdModule> {
        return {
            ngModule: StdModule,
            providers: [
                ...UtilityModule.getRootProviders(),
                ...ComponentsModule.getRootProviders(),

                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: AuthHttpInterceptor,
                    multi: true,
                },
            ]
        };
    }

    static forChild(): ModuleWithProviders<StdModule> {
        return {
            ngModule: StdModule,
            providers: []
        };
    }

    static getRootProviders(): Array<Provider | EnvironmentProviders> {
        return [
            provideSvgIconsConfig({
                missingIconFallback: stdUnknownIcon,
                sizes: {
                    md: '24px',
                },
                defaultSize: 'md',
                icons: [...coreIcons]
            }),
            ...UtilityModule.getRootProviders(),
            ...ComponentsModule.getRootProviders(),
            {
                provide: HTTP_INTERCEPTORS,
                useClass: AuthHttpInterceptor,
                multi: true,
            },
            {
                provide: EndPointResolver,
                deps: [EnvironmentConfiguration]
            },
            // {
            //   provide: RESPONSE_CACHE_WEBWORKER_FACTORY,
            //   useValue: function (): Worker {
            //       return new Worker(new URL('projects/std/worker/response-cache/response-cache.worker', import.meta.url), {
            //           name: 'response-cache.worker',
            //           type: 'module',
            //       });
            //   },
            // },
            {
                provide: ResponseCacheService,
            },
            // {
            //   provide: SERIALIZATION_WEBWORKER_FACTORY,
            //   useValue: function (): Worker {
            //       return new Worker(new URL('projects/std/worker/serialization/serialization.worker', import.meta.url), {
            //           name: 'serialization.worker',
            //           type: 'module',
            //       });
            //   },
            // },
            {
                provide: WebApiServiceAgent,
                deps: [HttpClient, EndPointResolver, ResponseCacheService, OnlineService]
            },
            {
                provide: CurrentSessionService,
                deps: [AuthService]
            },
            {
                provide: FrameworkServiceApiClient,
                deps: [WebApiServiceAgent]
            },
            {
                provide: TokenService,
                deps: [AuthService, FrameworkServiceApiClient, ToastMessageService]
            },
            // Necessari per il logger
            {
                provide: LOG_DECYCLE_LIB, useValue: JsonNetDecycle
            },
            {
                provide: LOG_LEVEL,
                useFactory: (env: EnvironmentConfiguration) => env.logLevel,
                deps: [EnvironmentConfiguration]
            },
            ErrorNotificationService,
            // {
            //     provide: ErrorHandler,
            //     useClass: CustomErrorHandlerService,
            //     deps: [
            //         TelemetryService,
            //         EnvironmentConfiguration,
            //         ErrorNotificationService
            //     ]
            // },

            // NgForage Deps
            // {
            //   provide: DEFAULT_CONFIG,
            //   useValue: {
            //     name: 'NTS',
            //     driver: [ // defaults to indexedDB -> webSQL -> localStorage
            //       Driver.INDEXED_DB,
            //       Driver.LOCAL_STORAGE
            //     ]
            //   } as NgForageOptions
            // },

            // Initializer
            {
                provide: APP_INITIALIZER,
                useFactory: initializerFactoryFunction,
                deps: [
                    StdInitService,
                ],
                multi: true
            }
        ];
    }
}
